import React, {  useEffect } from 'react';
import { Archive } from 'lucide-react';


const Header = ({ isDarkMode,
    setSearchTerm,
    searchTerm,
    toggleDarkMode,
    darkMode = false,
    search = false,
}) => {

    // Cargar datos al iniciar y cuando cambien los filtros
    useEffect(() => {
    }, []);

    return (<header className={`py-6 ${isDarkMode ? 'bg-gray-800' : 'bg-white'} shadow-md`}>
        <div className="container mx-auto px-4 flex justify-between items-center">
            <div>
                <h1 className="text-2xl font-bold">Jorge Mendieta Mayen</h1>
                <p className="text-sm text-gray-500">🚀 Director de Desarrollo | Arquitectura Evolutiva | IA & Fintech | Estrategia Tech-Driven Diseñando plataformas escalables y seguras para entornos financieros y de alto impacto.</p>
            </div>
            <div className="flex items-center space-x-4">
                {search&&<div className="relative hidden md:block">
                    <input
                        type="text"
                        placeholder="Buscar noticias..."
                        className={`pl-10 pr-4 py-2 rounded-full ${isDarkMode ? 'bg-gray-700 text-white' : 'bg-gray-100'} focus:outline-none focus:ring-2 focus:ring-blue-500`}
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                    <span className="absolute left-3 top-2.5 text-gray-400">🔍</span>
                </div>}
                
                {darkMode  && <button
                    onClick={toggleDarkMode}
                    className={`p-2 rounded-full ${isDarkMode ? 'bg-gray-700' : 'bg-gray-100'}`}
                >
                    {isDarkMode ? '☀️' : '🌙'}
                </button>}
            </div>
        </div>
    </header>)

}


export default Header;